const stats = require('../../lib/util/math/stats');
const template = require('./success-criteria-report.tpl').default;

module.exports = DomClass(template, function SuccessCriteriaReport () {
	var _t = this;

	this.refresh = function() {
		_t.successRate = (100 * stats.drawSuccess(
			_t.min * 1,
			_t.max * 1,
			_t.end * 1 + 7,
			_t.matches * 1,
			_t.population * 1
		)).toFixed(1) + "%";
	};

	this.refresh();

});
